import script from "./SellersPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./SellersPoints.vue?vue&type=script&setup=true&lang=js"

import "./SellersPoints.vue?vue&type=style&index=0&id=12d19abb&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.25_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d19abb"]])

export default __exports__